import { render, staticRenderFns } from "./BaseCardList.vue?vue&type=template&id=29170069&scoped=true"
import script from "./BaseCardList.vue?vue&type=script&lang=js"
export * from "./BaseCardList.vue?vue&type=script&lang=js"
import style0 from "./BaseCardList.vue?vue&type=style&index=0&id=29170069&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29170069",
  null
  
)

export default component.exports